import encryptServer from '@/request/encryptRequest';

// 提货订单列表(分页)
export const queryPage = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/order/pageList', data);
};

// 提货订单日志
export const orderLogs = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/log/pageList', data);
};

// 提货订单详情(新)
export const queryOrderDetail = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/order/detail', data);
};

// 订单数量统计
export const querySaleOrderCount = (data = {}) => {
  return encryptServer.post('/xiaozi-saas/wireless/sale/order/count', data);
};
